const formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
const signedFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', signDisplay: 'always' })
const amountFormatter = new Intl.NumberFormat('fr-FR')

export const formatCurrency = (amount, { signed = false } = {}) =>
  signed ? signedFormatter.format(amount) : formatter.format(amount)

export const formatAmount = (amount) => amountFormatter.format(amount)
